"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleLoadMessage = void 0;
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.BattleLoadMessage = message_1.createMessage('battle/load', joi_1.default.object({
    battleId: joi_1.default.string().required()
}))
    .withResponse();
